class GameObject
  drawable: undefined

  images: []

  constructor: (@x, @y, @gridHelper) ->
    @moveSpeed = 5
    @findPath  = @gridHelper.findPath
    @adjust    = @gridHelper.adjust


  update: (player) =>
    [ x, y ] = @adjust this, player
    [ @drawable.x, @drawable.y ] = [x, y]


  createImages : (images) ->
    images.map (filename) ->
      new createjs.Bitmap("./data/#{filename}")


module.exports = GameObject
